import { getApiBaseUrl } from '../../../utils/apiConfig';
import { sendOSEmailSystem } from '../services/osService';
import { fetchNotificationTypes } from '../../process-config/services/emailNotificationsService';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export function isOpenOsEmailAddr(value) {
  return EMAIL_RE.test(String(value || '').trim());
}

function todayPtBr() {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

function emailShell({ headerTitle, headerSub, intro, body, empresaNome }) {
  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"></head><body style="margin:0;padding:0;font-family:sans-serif;background:#f5f5f5"><table width="100%" cellpadding="0" cellspacing="0" style="background:#f5f5f5"><tr><td align="center" style="padding:20px"><table width="600" cellpadding="0" cellspacing="0" style="background:#fff;border-radius:8px"><tr><td style="background:linear-gradient(135deg,#e8f0f7,#f0f4f8);padding:28px 16px;text-align:center;border-bottom:2px solid #d0dce6"><h1 style="margin:0;color:#1a3a52;font-size:28px">${headerTitle}</h1><p style="margin:10px 0 0 0;color:#5a7a8a;font-size:16px">${headerSub}</p></td></tr><tr><td style="padding:30px"><p style="margin:0 0 25px 0;color:#333;font-size:15px;line-height:1.6">Prezado cliente,<br><br>${intro}</p>${body}</td></tr><tr><td style="background:#f9fafb;padding:20px 30px;border-top:1px solid #e8e8e8"><p style="margin:0;color:#888;font-size:12px">${empresaNome || ''}</p></td></tr></table></td></tr></table></body></html>`;
}

function contactAndNotesHtml(ctx) {
  const solicitante = ctx.solicitante || 'N/A';
  const contato = ctx.contato || 'N/A';
  const defeito = ctx.defeito || 'N/A';
  const obs = ctx.obs || 'Nenhuma observação adicional.';
  return `<div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Dados de Contato</h2><table width="100%" cellpadding="0" cellspacing="0"><tr><td style="padding:10px 0;color:#666;font-size:14px;width:50%"><strong style="color:#333">Solicitante:</strong><br><span style="color:#555">${solicitante}</span></td><td style="padding:10px 0 10px 20px;color:#666;font-size:14px;width:50%"><strong style="color:#333">Contato:</strong><br><span style="color:#555">${contato}</span></td></tr></table></div><div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Descrição do Defeito</h2><div style="padding:15px;background:#f9fafb;border-left:4px solid #2c5aa0;border-radius:4px"><p style="margin:0;color:#555;font-size:14px;line-height:1.6">${defeito}</p></div></div><div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Observações Adicionais</h2><div style="padding:15px;background:#f9fafb;border-left:4px solid #d0dce6;border-radius:4px"><p style="margin:0;color:#555;font-size:14px;line-height:1.6">${obs}</p></div></div>`;
}

function osAddressLabel(os, ctx) {
  const loc = String((os && (os.LOCALIZACAO || os.local)) || '').trim();
  const street = [
    os && os.END_LOGRADOURO,
    os && os.END_NUM,
    os && os.END_BAIRRO,
    os && os.END_CIDADE,
    os && os.END_ESTADO,
  ].filter(Boolean).join(', ');
  const rawAddr = String((os && os.endereco) || '').trim();
  const streetPart = street || rawAddr;
  if (streetPart && loc) return `${streetPart} — ${loc}`;
  if (streetPart) return streetPart;
  if (loc) return loc;
  return String((ctx && ctx.endereco) || '').trim() || 'N/A';
}

function groupOsByAddress(oss, ctx) {
  const groups = [];
  const map = new Map();
  (oss || []).forEach((os) => {
    const key = osAddressLabel(os, ctx);
    let group = map.get(key);
    if (!group) {
      group = { address: key, items: [] };
      map.set(key, group);
      groups.push(group);
    }
    group.items.push(os);
  });
  return groups;
}

function osNumbersHeaderHtml(numeros) {
  return numeros.map((n) => (
    `<strong style="color:#2c5aa0;font-size:20px">${n}</strong>`
  )).join('<span style="color:#a8b8c8;margin:0 6px">·</span>');
}

function equipmentGroupsHtml(oss, ctx) {
  const groups = groupOsByAddress(oss, ctx);
  const blocks = groups.map((g) => {
    const rows = g.items.map((os, i) => {
      const border = i === g.items.length - 1 ? 'none' : '1px solid #f2f2f7';
      const modelo = os.modelo || ctx.modelo || '—';
      const serie = os.serie || ctx.serie || '—';
      return `<tr><td style="padding:8px 10px 8px 0;border-bottom:${border};vertical-align:top;width:92px"><span style="color:#2c5aa0;font-size:13px;font-weight:700">${os.numero}</span></td><td style="padding:8px 0;border-bottom:${border};vertical-align:top"><span style="color:#333;font-size:13px;font-weight:600">${modelo}</span><br><span style="color:#888;font-size:12px">${serie}</span></td></tr>`;
    }).join('');
    return `<div style="margin:0 0 14px 0"><div style="font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#8a8a9e;font-weight:700;margin-bottom:6px">${g.address}</div><table width="100%" cellpadding="0" cellspacing="0">${rows}</table></div>`;
  }).join('');
  return `<div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Dados do Equipamento</h2>${blocks}</div>`;
}

export function buildOpenOsAberturaEmailHtml(ctx) {
  const osNumber = ctx.osNumber || '—';
  const dataFormatada = ctx.dataFormatada || todayPtBr();
  const modelo = ctx.modelo || '';
  const serie = ctx.serie || '';
  const endereco = ctx.endereco || 'N/A';
  const empresaNome = ctx.empresaNome || '';
  const body = `<div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Dados do Chamado</h2><table width="100%" cellpadding="0" cellspacing="0"><tr><td style="padding:10px 0;color:#666;font-size:14px;width:50%"><strong style="color:#333">Número da OS:</strong><br><span style="color:#2c5aa0">${osNumber}</span></td><td style="padding:10px 0 10px 20px;color:#666;font-size:14px;width:50%"><strong style="color:#333">Data de Abertura:</strong><br><span style="color:#555">${dataFormatada}</span></td></tr></table></div><div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Dados do Equipamento</h2><table width="100%" cellpadding="0" cellspacing="0"><tr><td style="padding:10px 0;color:#666;font-size:14px;width:50%"><strong style="color:#333">Modelo:</strong><br><span style="color:#555">${modelo}</span></td><td style="padding:10px 0 10px 20px;color:#666;font-size:14px;width:50%"><strong style="color:#333">Número de Série:</strong><br><span style="color:#555">${serie}</span></td></tr><tr><td colspan="2" style="padding:10px 0;color:#666;font-size:14px"><strong style="color:#333">Endereço:</strong><br><span style="color:#555">${endereco}</span></td></tr></table></div>${contactAndNotesHtml(ctx)}`;
  return emailShell({
    headerTitle: 'Ordem de serviço aberta',
    headerSub: `Número: <strong style="color:#2c5aa0;font-size:20px">${osNumber}</strong>`,
    intro: 'Confirmamos a abertura de uma nova ordem de serviço para o seu equipamento.',
    body,
    empresaNome,
  });
}

export function buildOpenOsAberturaMultiEmailHtml(oss, ctx) {
  const dataFormatada = (ctx && ctx.dataFormatada) || todayPtBr();
  const numeros = (oss || []).map((o) => o.numero);
  const numsLine = numeros.map((n) => `<span style="color:#2c5aa0">${n}</span>`).join('<span style="color:#c5cdd6"> · </span>');
  const body = `<div style="margin-bottom:25px"><h2 style="margin:0 0 15px 0;color:#2c5aa0;font-size:16px;border-bottom:2px solid #e8f0f7;padding-bottom:10px">Dados do Chamado</h2><table width="100%" cellpadding="0" cellspacing="0"><tr><td style="padding:10px 0;color:#666;font-size:14px"><strong style="color:#333">Ordens de serviço:</strong><br><span style="font-size:15px;font-weight:700;letter-spacing:.01em">${numsLine}</span></td></tr><tr><td style="padding:10px 0;color:#666;font-size:14px"><strong style="color:#333">Data de Abertura:</strong><br><span style="color:#555">${dataFormatada}</span></td></tr></table></div>${equipmentGroupsHtml(oss, ctx || {})}${contactAndNotesHtml(ctx || {})}`;
  return emailShell({
    headerTitle: 'Ordens de serviço abertas',
    headerSub: osNumbersHeaderHtml(numeros),
    intro: 'Confirmamos a abertura das ordens de serviço abaixo para os equipamentos relacionados.',
    body,
    empresaNome: (ctx && ctx.empresaNome) || '',
  });
}

function multiOsSubject(oss) {
  const nums = (oss || []).map((o) => o.numero);
  const joined = nums.join(', ');
  if (joined.length <= 72) return `Ordens de Serviço ${joined} - Abertura confirmada`;
  return `Ordens de Serviço abertas (${nums.length}) - Abertura confirmada`;
}

async function sendViaUserSmtp(to, subject, html, osNumber, empresaCodigo) {
  const token = localStorage.getItem('authToken');
  let userId = null;
  try {
    const user = JSON.parse(localStorage.getItem('userData') || 'null');
    userId = user && user.id ? user.id : null;
  } catch (err) {
    userId = null;
  }
  const res = await fetch(`${getApiBaseUrl()}/api/os/send-email`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userId,
      to,
      subject,
      html,
      osNumber,
      empresaCodigo: empresaCodigo || '',
      useSystemFallback: true,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Erro ao enviar email');
  }
  return data;
}

function empresaCodigoOf(os, ctx) {
  return String((os && os.codEmp) || (ctx && ctx.empresaCodigo) || '').trim();
}

export async function sendOpenOsAberturaEmails({ recipients, osItems, ctx, viaSystem }) {
  const list = (recipients || []).map((e) => String(e || '').trim().toLowerCase()).filter(isOpenOsEmailAddr);
  const oss = (osItems || []).filter((o) => o && o.success && o.numero && o.numero !== '—');
  if (!list.length || !oss.length) throw new Error('Informe ao menos um e-mail válido');
  const dataFormatada = todayPtBr();
  const emailCtx = { ...(ctx || {}), dataFormatada };
  const isMulti = oss.length > 1;
  const html = isMulti
    ? buildOpenOsAberturaMultiEmailHtml(oss, emailCtx)
    : buildOpenOsAberturaEmailHtml({
      osNumber: oss[0].numero,
      dataFormatada,
      modelo: oss[0].modelo || emailCtx.modelo,
      serie: oss[0].serie || emailCtx.serie,
      endereco: emailCtx.endereco,
      solicitante: emailCtx.solicitante,
      contato: emailCtx.contato,
      defeito: emailCtx.defeito,
      obs: emailCtx.obs,
      empresaNome: emailCtx.empresaNome,
    });
  const subject = isMulti
    ? multiOsSubject(oss)
    : `Ordem de Serviço ${oss[0].numero} - Abertura confirmada`;
  const empresaCodigo = empresaCodigoOf(oss[0], emailCtx);
  const osNumber = isMulti ? oss.map((o) => o.numero).join(',') : oss[0].numero;
  for (let r = 0; r < list.length; r += 1) {
    if (viaSystem) {
      const sent = await sendOSEmailSystem(list[r], subject, html, empresaCodigo);
      if (!sent || !sent.success) throw new Error((sent && sent.message) || 'Erro ao enviar email');
    } else {
      await sendViaUserSmtp(list[r], subject, html, osNumber, empresaCodigo);
    }
  }
}

export async function maybeAutoSendOpenOsEmails({ recipients, osItems, ctx }) {
  const list = (recipients || []).map((e) => String(e || '').trim().toLowerCase()).filter(isOpenOsEmailAddr);
  if (!list.length) return;
  const token = localStorage.getItem('authToken');
  if (!token) return;
  try {
    const nt = await fetchNotificationTypes(token);
    if (!nt || !nt.abertura_os) return;
    await sendOpenOsAberturaEmails({ recipients: list, osItems, ctx });
  } catch (err) {
    return { error: (err && err.message) || 'Erro ao enviar email' };
  }
}
